import React from 'react'
import cx from 'classnames'
import './Typography.scss'

const Heading5 = ({ children, white, left, className, green, gray, center, onClick }) => (
    <h5 className={cx(className, 'heading5', left && 'text-left', white ? 'heading-white' : '', green ? 'heading-green' : '', gray ? 'heading-5-gray' : '', center ? 'text-center' : '')} onClick={onClick}>
        {children}
    </h5>
)

export default Heading5



// WEBPACK FOOTER //
// /usr/src/site-blog/src/components/site/typography/Heading5.jsx